import { render } from "./TaxRate.vue?vue&type=template&id=c2def928&scoped=true"
import script from "./TaxRate.vue?vue&type=script&lang=js"
export * from "./TaxRate.vue?vue&type=script&lang=js"

import "./TaxRate.vue?vue&type=style&index=0&id=c2def928&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2def928"]])

export default __exports__